import VALID_TLDs from '@/constants/tlds.js'
import axios from 'axios'

export default {
    check: function(domain){
        return new Promise(function(resolve, reject) {
            if(domain === ''){
                resolve(null);
            }else{
                if (/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(domain)){
                    var has_one = false;
                    for(var i=0; i<VALID_TLDs.length; i++){
                        if( domain.slice(-VALID_TLDs[i].length) === VALID_TLDs[i]){
                            has_one = true;
                        }
                    }
                    if(!has_one){
                        resolve('invalid_tld');
                    }else{
                        axios.post('/portfolio/domain/', {domain: domain}).then(data => {
                            if(data.data.available && !data.data.error){
                                resolve('available');
                            }else{
                                resolve('unavailable');
                            }
                        })
                    }
                }else{
                    resolve('invalid');
                }
            }
        })
    }
}